import styled from 'styled-components';
import { black, border1 } from 'utils/style/colors';

import { screenLargerThan } from 'utils/style/responsive';

type UserSearchInputProps = {
  withoutButton: boolean;
};

export const LimitationInputs = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  ${screenLargerThan.phone`
      flex-direction: row
  `}
  & > div {
    flex: 1;
    height: 6rem;
    width: 100%;
  }
`;

export const UserSearchInputContainer = styled('div')<UserSearchInputProps>`
  margin: 1rem 0;
  display: flex;
  align-items: center;
  flex-direction: ${({ withoutButton }) => (withoutButton ? 'column' : 'row')};
  justify-content: center;
  & > label {
    align-self: flex-start;
    margin-right: 0.3rem;
    color: #9e9e9e !important;
    font-size: 0.8rem !important;
  }
`;

export const UserSearchInput = styled('input')`
  color: #344b47;
  font-weight: 400;
  border: ${border1} !important;
  height: 47px !important;
  margin: 0.5rem 0.3rem !important;
  padding: 0 1em 0 1em !important;
  font-size: 14px !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
  background-color: var(--exact-white) !important;
  &::placeholder {
    color: #96b1ac;
  }
  &:focus {
    border: 1px solid #34c8b6 !important;
    box-shadow: 0 0 2px #34c8b6 !important;
    background-color: var(--exact-white) !important;
  }
  &:hover {
    border: 1px solid #34c8b6 !important;
  }
`;

export const userSearchMenuStyle: React.CSSProperties = {
  top: '4rem',
  width: '100%',
  zIndex: 999,
  display: 'flex',
  position: 'absolute',
  fontSize: '90%',
  overflow: 'auto',
  maxHeight: '12.5rem',
  marginRight: '0.3rem',
  background: 'var(--exact-white)',
  marginTop: '2px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  borderRadius: '4px',
  flexDirection: 'column',
};

export const AutoCompleteWrapperStyle: React.CSSProperties = {
  position: 'relative',
  flex: '0.6',
  width: '100%',
};

export const LimitationBoxWrapper = styled('div')`
  gap: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around ${screenLargerThan.desktop`
      flex-direction: row;
      & > div {
        flex: 1;
      }
  `};
`;

export const LimitationTable = styled('table')`
  color: ${black};
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  width: 100%;
`;

export const InfoRow = styled('div')`
  margin: 0 auto;
  border-radius: 10px;
  border: 1px solid ${(props) => props.color};
  padding: 10px;
`;
